import { Card, Flex, Icon, Switch, Text } from '@chakra-ui/react';
import { CalendarIcon } from 'lucide-react';
import { NewText } from '~/common/components/NewText/NewText';
import { IndigoLogoGradient } from '~/common/icons/IndigoLogoGradient';
import { useListingPageContext } from './ListingPageContext';

export const ListingPageConfigs = () => {
  const { includeIndigoData, setIncludeIndigoData, confidence } =
    useListingPageContext();

  return (
    <Flex
      alignItems={{ base: 'flex-start', md: 'center' }}
      bg="transparent"
      direction={{ base: 'column', md: 'row' }}
      gap={4}
      justifyContent="flex-end"
      pb={{ base: 2, md: 4 }}
      position={{ base: 'relative', md: 'sticky' }}
      pt={{ base: 0, md: 8 }}
      px={{ base: 0, md: 0 }}
      top={0}
      width="100%"
      zIndex={100}
    >
      <Flex gap={2}>
        {!!confidence?.maxTimePeriodMonths && (
          <Card p={2}>
            <Flex alignItems="center" color="whiteAlpha.600" gap={2}>
              <Icon as={CalendarIcon} />
              <Text fontSize="sm" fontWeight="medium">
                {confidence?.maxTimePeriodMonths} months
              </Text>
            </Flex>
          </Card>
        )}
        <Card p={2}>
          <Flex alignItems="center" gap={2}>
            <IndigoLogoGradient />
            <Flex>
              <Text fontSize="sm" fontWeight="medium">
                Include Indigo Offer Data
              </Text>
              <NewText text="PRO" />
            </Flex>
            <Switch
              isChecked={includeIndigoData}
              size="sm"
              variant="gradient"
              onChange={() => setIncludeIndigoData(!includeIndigoData)}
            />
          </Flex>
        </Card>
      </Flex>
    </Flex>
  );
};
